module.exports = __webpack_public_path__ + "static/media/chevron-down.b70825cf.svg";